const {
    ROOT_BASKET_TYPES,
    MAIN_BASKET_TYPES: { DC_BASKET, BOPIS_BASKET },
    DC_BASKET_TYPES: { SAMEDAY_BASKET, AUTOREPLENISH_BASKET, STANDARD_BASKET }
} = require('constants/RwdBasket');

function getPickupFromStoreInfo({ pickupBasket }) {
    const { isROPISEnabled, isBOPISEnabled } = Sephora.configurationSettings;
    const bopisIsEnabled = isROPISEnabled || isBOPISEnabled;

    if (pickupBasket == null) {
        return {
            isAvailable: false
        };
    }

    const { items } = pickupBasket;

    return {
        isAvailable: bopisIsEnabled && items.length > 0,
        items
    };
}

function getSameDayDeliveryInfo({ itemsByBasket }) {
    const { isSameDayShippingEnabled } = Sephora.configurationSettings;
    const sdd = itemsByBasket?.find(e => e.basketType === SAMEDAY_BASKET);

    if (sdd == null) {
        return {
            isAvailable: false
        };
    }

    const { items } = sdd;

    return { items, isAvailable: isSameDayShippingEnabled };
}

function getStandardShippingInfo({ itemsByBasket, remainToFreeShipping }) {
    const standard = itemsByBasket?.find(e => e.basketType === STANDARD_BASKET);

    if (standard == null) {
        return { isAvailable: false };
    }

    const { items } = standard;

    return { items, isAvailable: true, remainToFreeShipping };
}

// TODO (INFL-1941)
function getAutoreplenishInfo() {
    return { isAvailable: false, items: [] };
}

function isPreBasketAvailable(basket) {
    // As of now, the only condition for showing PreBasket is that there is a Pickup/Bopis cart
    return getPickupFromStoreInfo(basket).isAvailable;
}

function calculateRootBasketType(basket) {
    // current rule is to render PreBasket if there are Bopis items
    if (isPreBasketAvailable(basket)) {
        return {
            currentRootBasketType: ROOT_BASKET_TYPES.PRE_BASKET,
            // currentMainBasketType will be set by user action on PreBasket
            currentMainBasketType: null
        };
    }

    return {
        currentRootBasketType: ROOT_BASKET_TYPES.MAIN_BASKET,
        // Default MAIN_BASKET_TYPE is DC because if we had BOPIS items, we would be rendering PreBasket
        currentMainBasketType: DC_BASKET
    };
}

function calculateAvailableCarts(basket) {
    return {
        [BOPIS_BASKET]: getPickupFromStoreInfo(basket),
        [SAMEDAY_BASKET]: getSameDayDeliveryInfo(basket),
        [STANDARD_BASKET]: getStandardShippingInfo(basket),
        [AUTOREPLENISH_BASKET]: getAutoreplenishInfo(basket)
    };
}

function getTargetUrl(item) {
    return item.sku.fullSizeSku && item.sku.fullSizeSku.targetUrl ? item.sku.fullSizeSku.targetUrl : item.sku.targetUrl;
}

module.exports = {
    calculateRootBasketType,
    calculateAvailableCarts,
    isPreBasketAvailable,
    getTargetUrl
};
